module.exports = __webpack_public_path__ + "static/014-slideshow-085ef6bc9851441abb700755d1468c09.jpg";